import * as React from 'react';
import { ComponentProps, NoValueDash, InfoText, Label } from 'ui/common';
import { PreviousValuesButton } from './common/previous-values-button';
import { PreviousEnvironmentalValuesShape } from 'app/area/case/selectors';
import { SectionLink } from 'app/area/case/components/fact-box/types';
import { DisplayNumber } from 'ui';
import { DisplayNumberProps } from 'ui/display-number/display-number';
import { DisplayDateProps } from 'ui/display-date/display-date';
import { TextIcon } from 'ui/common/icons/text-icon';
import styles from './display-environmental-previous-values.scss';

interface Translations {
  /**
   * Text on the modal dialog to close the window
   */
  textDone: string;
  /**
   * Text link to open the modal dialog
   */
  textMoreDetails: string;
  /**
   * Header text for the modal dialog
   */
  textDetailsHeaderTitle: string;
  /**
   * Tooltip text indicating more than one prev values
   */
  textMoreThanOnePrevValues: string;
  /**
   * Label text for amount value in details
   */
  textDetailsAmount: string;
  /**
   * Label text for start period in details
   */
  textDetailsPeriodStart: string;
  /**
   * Label text for end period in details
   */
  textDetailsPeriodEnd: string;
}

interface PreviousEnvironmentalValuesProps {
  /**
   * When true, the component gets hidden when value is empty
   */
  hideIfNoValue: boolean;
}

type DisplayEnvironmentalPreviousValuesProps =
  ComponentProps & DisplayNumberProps & DisplayDateProps & PreviousEnvironmentalValuesProps &
  PreviousEnvironmentalValuesShape & Translations & SectionLink;

export const DisplayEnvironmentalPreviousValuesComponent: React.FC<DisplayEnvironmentalPreviousValuesProps> = props => {
  const { componentId, className, label, previousEnvironmentalValues, hideIfNoValue = false } = props;

  const hasChildren = previousEnvironmentalValues && !!previousEnvironmentalValues.length;
  const firstPrevValueAmount = hasChildren && previousEnvironmentalValues[0].amount;
  const firstPrevValueUoM = hasChildren && previousEnvironmentalValues[0].unitOfMeasure;
  const hasMoreThanOnePrevValues = hasChildren && previousEnvironmentalValues.length > 1;

  const hideComponent = hideIfNoValue && !hasChildren;
  const displayNoValueDash = !hideIfNoValue && !hasChildren && label && label.visible;

  const infoIcon = <>
    <TextIcon text="!" className={styles.tooltipIcon} />
  </>;

  return (
    !hideComponent && <div id={componentId} className={`${className} ${styles.envPrevValues}`}>
      {hasChildren &&
        <div className={styles.firstPrevValueWrapper}>
          <Label label={props.label} classNames="label" />
          <div className={styles.valueAndLinkWrapper}>
            <DisplayNumber {...props} label={{ ...props.label, visible: false }} className={styles.firstPrevValue}
              valueItem={{ value: firstPrevValueAmount }} suffix={firstPrevValueUoM} strong={true} />
            <span>
              <PreviousValuesButton {...props} />
              {hasMoreThanOnePrevValues &&
                <InfoText className={styles.infoTextWrapper} visible={true} text={props.textMoreThanOnePrevValues} infoIcon={infoIcon} />
              }
            </span>
          </div>
        </div>}
      {displayNoValueDash &&
        <div>
          {label && <label className="label">{label.text}</label>}
          <NoValueDash />
        </div>}
    </div>
  );
};
